import { API } from "@/lib/api";

const VID_KEY = "neec_vid";
const SID_KEY = "neec_sid";
const UTM_KEY = "neec_utm";

function uuid() {
  return (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
}

let isNewVisitor = false;
function getVisitorId() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) { v = uuid(); localStorage.setItem(VID_KEY, v); isNewVisitor = true; }
  return v;
}
function getSessionId() {
  let s = sessionStorage.getItem(SID_KEY);
  if (!s) { s = uuid(); sessionStorage.setItem(SID_KEY, s); }
  return s;
}
export function getUTM() {
  try {
    const p = new URLSearchParams(window.location.search);
    const fresh = ["source", "medium", "campaign"].reduce((a, k) => {
      const val = p.get(`utm_${k}`); if (val) a[`utm_${k}`] = val.slice(0, 120); return a;
    }, {});
    if (Object.keys(fresh).length) sessionStorage.setItem(UTM_KEY, JSON.stringify(fresh));
    return JSON.parse(sessionStorage.getItem(UTM_KEY) || "{}");
  } catch { return {}; }
}
function device() {
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

export function track(type, extra = {}) {
  try {
    if (window.location.pathname.startsWith("/admin")) return;
    const utm = getUTM();
    const body = JSON.stringify({
      type, section: extra.section || "", path: window.location.pathname,
      referrer: document.referrer || "", device: device(),
      visitor_id: getVisitorId(), session_id: getSessionId(), is_new: isNewVisitor,
      utm_source: utm.utm_source || "", utm_medium: utm.utm_medium || "", utm_campaign: utm.utm_campaign || "",
    });
    const url = `${API}/track`;
    if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    else fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch { /* never block UI */ }
}

export function trackPageview() {
  getVisitorId();
  track("pageview");
}
